import { eTipoPermissao } from "@/enums/ePermissoes";

export default [
 {
  description: "Solicitação para Reposição Escola",
  path: "/merenda/mersolicitacaoescola",
  name: "mersolicitacaoescola",
  component: () => import("@/views/merenda/mersolicitacaoescola/Index.vue"),
  meta: {
   permissions: [eTipoPermissao.SOLICITACAOREPOSICAOESCOLANOVO_MENU_1900300299],
   alimentacao: false,
  },
  goesToMenu: true,
 },
 {
  description: "Cadastro de Solicitação para Reposição Escola",
  path: "/merenda/mersolicitacaoescola/cadastro/:id?",
  parent: "mersolicitacaoescola",
  name: "mersolicitacaoescola_create",
  component: () => import("@/views/merenda/mersolicitacaoescola/InclusaoEdicao.vue"),
  meta: {
   permissions: [eTipoPermissao.SOLICITACAOREPOSICAOESCOLANOVO_MENU_1900300299],
   alimentacao: false,
  },
  goesToMenu: true,
 },
 {
  description: "Itens da Solicitação para Reposição Escola",
  path: "/merenda/mersolicitacaoescola/:id/itens",
  parent: "mersolicitacaoescola",
  name: "mersolicitacaoescola_itens",
  component: () => import("@/views/merenda/mersolicitacaoescola/Itens.vue"),
  meta: {
   permissions: [eTipoPermissao.SOLICITACAOREPOSICAOESCOLANOVO_MENU_1900300299],
   alimentacao: false,
  },
  goesToMenu: false,
 },
 {
  description: "Solicitacao Alimentacao",
  path: "/merenda/mersolicitacaoalimentacao",
  name: "mersolicitacaoalimentacao",
  component: () => import("@/views/merenda/mersolicitacaoescola/Index.vue"),
  meta: {
   permissions: [eTipoPermissao.SOLICITACAOREPOSICAOALIMENTACAONOVO_MENU_1000400299],
   alimentacao: true,
  },
  goesToMenu: true,
 },
 {
  description: "Cadastro de Solicitacao Alimentacao",
  path: "/merenda/mersolicitacaoalimentacao/cadastro/:id?",
  parent: "mersolicitacaoalimentacao",
  name: "mersolicitacaoalimentacao_create",
  component: () => import("@/views/merenda/mersolicitacaoescola/InclusaoEdicao.vue"),
  meta: {
   permissions: [eTipoPermissao.SOLICITACAOREPOSICAOALIMENTACAONOVO_MENU_1000400299],
   alimentacao: true,
  },
  goesToMenu: true,
 },
 {
  description: "Itens da Solicitacao Alimentacao",
  path: "/merenda/mersolicitacaoalimentacao/:id/itens",
  parent: "mersolicitacaoalimentacao",
  name: "mersolicitacaoalimentacao_itens",
  component: () => import("@/views/merenda/mersolicitacaoescola/Itens.vue"),
  meta: {
   permissions: [eTipoPermissao.SOLICITACAOREPOSICAOALIMENTACAONOVO_MENU_1000400299],
   alimentacao: true,
  },
  goesToMenu: false,
 },
]
